// Only these two visual/audio-meter loops opt into the browser-test driver.
// Resolve once per loop, not per frame. Without the explicit test injection,
// pass callbacks, native RAF timestamps, handles and cancellation straight
// through; never replace any global timing API.
function createFrameScheduler(channel) {
  const driver = window.__BR_VOICE_FRAME_TEST_DRIVER__;
  if (driver && typeof driver.request === 'function' && typeof driver.cancel === 'function') {
    return {
      request: (callback) => driver.request(channel, callback),
      cancel: (handle) => driver.cancel(channel, handle),
    };
  }
  return {
    request: window.requestAnimationFrame.bind(window),
    cancel: window.cancelAnimationFrame.bind(window),
  };
}

export const createAnalyserFrameScheduler = () => createFrameScheduler('analyser');
export const createOrbFrameScheduler = () => createFrameScheduler('orb');
